import type { PayloadAction } from '@reduxjs/toolkit'

export const toBoolAction = <T extends PayloadAction<any>>(a: T) => ({
	...a,
	payload: Boolean(a.payload),
})
